export type Environment = 'production' | 'staging'

export const isDev = () =>
  Boolean(typeof document !== 'undefined' && document.location.href.startsWith('http://localhost:'))
